export { default } from "./ReadAloudSpeedOption";
